export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function extractErrorMessage(value: unknown): string | null {
  if (typeof value === 'string' && value.trim()) return value;

  if (!isRecord(value)) return null;

  const errValue = value.err;
  if (typeof errValue === 'string' && errValue.trim()) return errValue;

  if (isRecord(errValue)) {
    const candidateKeys = ['message', 'msg', 'error'];
    for (const key of candidateKeys) {
      const candidate = errValue[key];
      if (typeof candidate === 'string' && candidate.trim()) {
        return candidate;
      }
    }
  }

  const candidateKeys = ['message', 'msg', 'error'];
  for (const key of candidateKeys) {
    const candidate = value[key];
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate;
    }
  }

  return null;
}

export function normalizeArrayField<T>(value: unknown, fieldName: string, warnings: string[]): T[] {
  if (value == null) return [];
  if (Array.isArray(value)) return value as T[];

  if (isRecord(value)) {
    const errorMessage = extractErrorMessage(value);
    if (errorMessage) {
      warnings.push(`${fieldName}: ${errorMessage}`);
      console.error(`[backendData] ${fieldName} backend error`, {
        fieldName,
        receivedValue: value,
        errorMessage,
      });
      return [];
    }

    const nestedArrayKeys = ['data', 'items', 'balances', 'positions', 'rows'];
    for (const key of nestedArrayKeys) {
      const nestedValue = value[key];
      if (Array.isArray(nestedValue)) {
        warnings.push(`${fieldName} arrived under "${key}" instead of as an array.`);
        console.error(`[backendData] ${fieldName} shape mismatch`, {
          fieldName,
          receivedType: typeof value,
          receivedValue: value,
        });
        return nestedValue as T[];
      }
    }
  }

  warnings.push(`${fieldName} has an invalid format and could not be displayed.`);
  console.error(`[backendData] ${fieldName} shape mismatch`, {
    fieldName,
    receivedType: Array.isArray(value) ? 'array' : typeof value,
    receivedValue: value,
  });
  return [];
}
